import {
  titleUI,
  yesNoUI,
  yesNoSchema,
  dateOfDeathUI,
  dateOfDeathSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import { validations } from '../../validations';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['veteran-additional-title']),
    vaClaimsHistory: yesNoUI({
      title: content['veteran-additional-history'],
    }),
    diedOnDuty: yesNoUI({
      title: content['veteran-additional-died-on-duty'],
    }),
    veteranDateOfDeath: dateOfDeathUI({
      monthSelect: false,
      validations: [validations.isAfterVeteranBirthDate],
    }),
  },
  schema: {
    type: 'object',
    required: ['vaClaimsHistory', 'diedOnDuty', 'veteranDateOfDeath'],
    properties: {
      vaClaimsHistory: yesNoSchema,
      diedOnDuty: yesNoSchema,
      veteranDateOfDeath: dateOfDeathSchema,
    },
  },
};
